<template>
  <button type="button"
          :class="`btn ${btnClass}`">
    <i :class="`fa ${iconClass} align-middle mr-1`"></i>
    <span class="align-middle">{{ text }}</span>
  </button>
</template>

<style>

</style>

<script>
  export default {
    props: {
      btnClass: String,
      iconClass: String,
      text: String
    }
  };
</script>